// NO EDITAR A MANO
import type {FooterLinkSocial as Modulo} from "../../../../footer/link_social";

import siguenos from "./siguenos";
import siguenos_facebook from "./siguenos_facebook";
import siguenos_instagram from "./siguenos_instagram";
import siguenos_linkedin from "./siguenos_linkedin";
import siguenos_telegram from "./siguenos_telegram";
import siguenos_twitter from "./siguenos_twitter";
import siguenos_youtube from "./siguenos_youtube";
import url_facebook from "./url_facebook";
import url_instagram from "./url_instagram";
import url_linkedin from "./url_linkedin";
import url_telegram from "./url_telegram";
import url_twitter from "./url_twitter";
import url_youtube from "./url_youtube";

class FooterLinkSocial implements Modulo {
    /* STATIC */
    // public static ID: string = "footer.link_social";
    // public static VERSION: string = "2024.12.2-143826";
    // public static HASH: string = "4a863e5dd972030aa63206192aeeeb08";

    /* INSTANCE */
    public readonly siguenos: string;
    public readonly siguenos_facebook: string;
    public readonly siguenos_instagram: string;
    public readonly siguenos_linkedin: string;
    public readonly siguenos_telegram: string;
    public readonly siguenos_twitter: string;
    public readonly siguenos_youtube: string;
    public readonly url_facebook: string;
    public readonly url_instagram: string;
    public readonly url_linkedin: string;
    public readonly url_telegram: string;
    public readonly url_twitter: string;
    public readonly url_youtube: string;

    public constructor() {
        this.siguenos = siguenos;
        this.siguenos_facebook = siguenos_facebook;
        this.siguenos_instagram = siguenos_instagram;
        this.siguenos_linkedin = siguenos_linkedin;
        this.siguenos_telegram = siguenos_telegram;
        this.siguenos_twitter = siguenos_twitter;
        this.siguenos_youtube = siguenos_youtube;
        this.url_facebook = url_facebook;
        this.url_instagram = url_instagram;
        this.url_linkedin = url_linkedin;
        this.url_telegram = url_telegram;
        this.url_twitter = url_twitter;
        this.url_youtube = url_youtube;
    }

}

export default new FooterLinkSocial();
